import { Button, Modal, Select, Spin } from "antd";
import React, { useState } from "react";

export const AddNewColumn = ({ addRow, availableColumn, columnLoading }) => {
	const [selectedColumn, setSelectedColumn] = useState([]);
	const [visible, setVisible] = useState(false);
	return (
		<Spin spinning={columnLoading}>
			<Button type="primary" onClick={() => setVisible(true)}>
				Add Column
			</Button>
			{visible && (
				<Modal
					open={visible}
					onOk={() => {
						addRow(selectedColumn);
						setVisible(false);
						setSelectedColumn([]);
					}}
					onCancel={() => setVisible(false)}
					title="Add New Column"
				>
					<Select
						mode="multiple"
						value={selectedColumn}
						placeholder="Select Column"
						style={{ width: "100%" }}
						onChange={value => setSelectedColumn(value)}
					>
						{availableColumn.map(column => (
							<Select.Option key={column} value={column}>
								{column}
							</Select.Option>
						))}
					</Select>
				</Modal>
			)}
		</Spin>
	);
};

export default AddNewColumn;
